import { render, staticRenderFns } from "./ModalSamplePrepare.vue?vue&type=template&id=c2284102&scoped=true&"
import script from "./ModalSamplePrepare.vue?vue&type=script&lang=ts&"
export * from "./ModalSamplePrepare.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSamplePrepare.vue?vue&type=style&index=0&id=c2284102&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2284102",
  null
  
)

export default component.exports